import { Inject, Injectable } from '@angular/core';
import { NotificationGridSetting } from '../model/grid/notification-grid-setting';
import { NOTIFICATION_GRID_SETTINGS } from './../common-shared.tokens';

@Injectable()
export class NotificationGridSettingService {
  constructor(
    @Inject(NOTIFICATION_GRID_SETTINGS)
    private _notificationGridSettings: Map<string, NotificationGridSetting>
  ) {}

  getNotificationSettingsForGrid(gridName: string): NotificationGridSetting {
    return this._notificationGridSettings.get(gridName);
  }
}
